
// import router from "../router/index";
// import store from "../store";
import BaseApi from "./BaseApi";

export default class EquipmentService extends BaseApi {


    constructor(){
        super();
    }


    async list()
    {
        return this.http.get(`${this.baseUrl}/equipments`)
        .catch(this.handleErrorResponse);
    }


    async get(slug)
    {
        return this.http.get(`${this.baseUrl}/equipments/${slug}/edit`)
        .catch(this.handleErrorResponse);
    }

    async show(slug)
    {
        return this.http.get(`${this.baseUrl}/equipments/${slug}/show`)
        .catch(this.handleErrorResponse);
    }


    async store(data)
    {
        return this.http.post(`${this.baseUrl}/equipments/store`,data)
        .catch(this.handleErrorResponse);
    }

    async storeOutput(id, data)
    {
        return this.http.post(`${this.baseUrl}/outputs/${id}/equipment/store`,data)
        .catch(this.handleErrorResponse);
    }


    async update(slug, data)
    {
        return this.http.put(`${this.baseUrl}/equipments/${slug}/update`, data)
        .catch(this.handleErrorResponse);
    }



    async delete(slug)
    {
        return this.http.delete(`${this.baseUrl}/equipments/${slug}/delete`)
        .catch(this.handleErrorResponse);
    }

}